'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Constants


var _formSubReducerWrapper = require('../../../../../components/form/formSubReducerWrapper');

var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);

var _elementConstants = require('../../../../../../common/elements/elementConstants');

var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);

var _boardSharingFormConstants = require('./boardSharingFormConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSharedUserSubFormReducer = function addSharedUserSubFormReducer(state, action) {
    switch (action.type) {
        case ELEMENT_ACTION_TYPES.ELEMENT_SHARE:
            return _extends({}, state, { userEmail: { value: '' } });
        default:
            return state;
    }
};

exports.default = (0, _formSubReducerWrapper2.default)(addSharedUserSubFormReducer, _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/form/boardSharingFormReducer.js
// module id = 2193
// module chunks = 0